import { DataPoint } from '@src/types/DataPoint';
import { Device } from '@src/types/Device';
import { getFieldNameFromDataPoint } from '@src/utils/gridUtils';
import { DeviceDataTableRow } from './types';

function groupDataPointsByDevice(data: DataPoint[]): Map<string, DataPoint[]> {
  const map = new Map<string, DataPoint[]>();

  data.forEach((d) => {
    if (!d.pointAlias) {
      return;
    }

    const deviceId = d.overrideSourceDeviceId
      ? d.controllerId
      : d.sourceDeviceId || d.controllerId;

    const list = map.get(deviceId) ?? [];
    list.push(d);
    map.set(deviceId, list);
  });

  return map;
}

export function createRow(
  deviceDataPoints: DataPoint[],
  engineeringId: string,
  name?: string,
  type?: string,
): DeviceDataTableRow {
  const row = { id: engineeringId, name, type } as DeviceDataTableRow;

  deviceDataPoints.forEach((dataPoint) => {
    const fieldName = getFieldNameFromDataPoint(dataPoint);
    row[fieldName] = dataPoint;
  });

  return row;
}

export function getRows(
  data: DataPoint[],
  devices?: Device[],
): DeviceDataTableRow[] {
  if (!devices?.length) {
    return [];
  }

  const deviceDataPointsMap = groupDataPointsByDevice(data);

  return devices.map((device) => {
    const deviceDataPoints =
      deviceDataPointsMap.get(device.engineeringId) ?? [];
    return createRow(
      deviceDataPoints,
      device.engineeringId,
      device.name,
      device.type,
    );
  });
}
